import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', redirectTo: 'apps/auth/login', pathMatch: 'full' },
    { path: 'apps', redirectTo: 'apps/auth/login', pathMatch: 'full' },
    { path: 'apps/auth', redirectTo: 'apps/auth/login', pathMatch: 'full' },
    { path: 'apps/auth/login', redirectTo: 'apps/auth/login', pathMatch: 'full' },
    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'apps/file-manager', redirectTo: 'apps/file-manager', pathMatch: 'full', },

    // Auth routes for guests
    {
        path: 'apps',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'auth', loadChildren: () => import('app/modules/auth/auth.route') },
        ]
    },

    // Auth routes for authenticated users
    // {
    //     path: '',
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty'
    //     },
    //     children: [
    //         { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
    //         { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
    //     ]
    // },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [

            {
                path: 'apps',
                children: [
                    { path: 'file-manager', loadChildren: () => import('app/modules/admin/apps/file-manager/file-manager.routes') },
                    { path: 'settings', loadChildren: () => import('app/modules/admin/apps/file-manager/settings/settings.routes') },
                    //{ path: 'copilot', loadChildren: () => import('app/modules/admin/apps/copilot/copilot.component').then(m => m.CopilotComponent) }
                ]
            },

        ]
    }
];
